import React, {useEffect, useState} from "react";
import {Auth} from "aws-amplify";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";

function ProfileHeader(props: { cognitoUser: any, title: string, linkToHome: string, image?: string }) {
  const {cognitoUser, title, linkToHome, image} = props;
  const email = (cognitoUser as any).attributes?.email;

  async function signOut() {
    try {
      await Auth.signOut();
    } catch (error) {
      console.log('error signing out: ', error);
    }
  }

  const homeImage = image ? image : "/villa.png";
  const homeClass = image ? "logo192" : "logoVilla";

  return (
    <section className="container px-0 rounded">
      <nav className="navbar navbar-dark mt-3">
        <div className="navbar-brand">
          <h3>
            <Link to={linkToHome}>
              <img className={homeClass} src={homeImage} width="64" height="64" alt=""/>
            </Link>
            {title}
          </h3>
        </div>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"/>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto pt-4 text-right">
            <li className="nav-item pb-3">
              <Link to="/setup/link_device">
                <span>Link Device</span>
              </Link>
            </li>
            {<li className="nav-item pb-3">
              <Link to="/library">
                <span>Library</span>
              </Link>
            </li>}
            <li className="nav-item pb-3">
              <Link to="/customize_ai">
                <span>Customize AI</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/assistants">
                <span>Assistants</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/conversations">
                <span>Conversations</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/apps">
                App Integrations
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/performances">
                <span>Performances</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/recordings">
                <span>Recordings</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/terms">
                <span>Terms of Use</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <Link to="/privacy">
                <span>Privacy Policy</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <a href="https://www.villa.rocks">
                <span>Villa Rocks</span>
              </a>
            </li>
            <li className="nav-item pb-3">
              <Link to="/qa">
                <span>Q & A</span>
              </Link>
            </li>
            <li className="nav-item pb-3">
              <span>{email}</span>
            </li>
            <li className="nav-item">
              <Button onClick={signOut}>
                Sign Out
              </Button>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  );
}

export default ProfileHeader;
